<template>
    <div
        class="
            has-background-very-light-pink-two
            lb-full-height
            has-scroll-y
            is-scroll-hidden
        "
    >
        <session-detail-header v-bind="session"></session-detail-header>
        <div class="tabs is-centered has-shadow is-marginless">
            <ul class="has-text-weight-bold">
                <li
                    :class="
                        $route.query.tab == 'resume' || !$route.query.tab
                            ? 'is-active'
                            : ''
                    "
                >
                    <router-link
                        v-t="'Sessions.resume_tab_title'"
                        :to="{
                            name: 'session-detail',
                            query: { tab: 'resume' },
                        }"
                        replace
                    ></router-link>
                </li>
                <li
                    :class="
                        $route.query.tab == 'participants' ? 'is-active' : ''
                    "
                >
                    <router-link
                        v-t="'Sessions.participants_tab_title'"
                        :to="{
                            name: 'session-detail',
                            query: { tab: 'participants' },
                        }"
                        replace
                    ></router-link>
                </li>
                <li :class="$route.query.tab == 'questions' ? 'is-active' : ''">
                    <router-link
                        v-t="getSectionTitle"
                        :to="{
                            name: 'session-detail',
                            query: { tab: 'questions' },
                        }"
                        replace
                    ></router-link>
                </li>
            </ul>
        </div>
        <div class="section">
            <component
                :is="currentView"
                :questions="completeQuestions"
                :user-answers="session.session_answers"
                :isTreasurehunt="isTreasurehunt"
                :clues="completeClues"
                :content="content"
                :is-treasure-hunt="isTreasurehunt"
                :report-info="reportInfo"
            ></component>
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
import { fetchItem } from '@/services/API';
import SessionDetailHeader from '@/components/SessionDetailHeader';
import SessionDetailGeneralResume from '@/components/SessionDetailGeneralResume';
import SessionDetailPlayers from '@/components/SessionDetailPlayers';
import SessionDetailQuestionsList from '@/components/SessionDetailQuestionsList';
export default {
    components: {
        SessionDetailHeader,
        SessionDetailPlayers,
        SessionDetailQuestionsList,
        SessionDetailGeneralResume,
    },
    props: {
        _id: {
            type: String,
            default: undefined,
        },
    },
    metaInfo() {
        return {
            title: this.session.title,
            titleTemplate: '%s - Labylok',
        };
    },
    data() {
        return {
            session: {},
            isTreasurehunt: false,
        };
    },
    computed: {
        currentView() {
            switch (this.$route.query.tab) {
                case 'questions':
                    return SessionDetailQuestionsList;
                    break;
                case 'participants':
                    return SessionDetailPlayers;
                    break;
                case 'resume':
                    return SessionDetailGeneralResume;
                    break;
                default:
                    return SessionDetailGeneralResume;
            }
        },
        groupedScores() {
            return _.groupBy(this.session.scores, (answer) => {
                return answer.object;
            });
        },
        questions() {
            const totalQuestions = _.filter(
                this.session.context,
                (question) => {
                    return question.type == 'question' || question.answers;
                }
            );
            // console.log('total questions', totalQuestions);
            return totalQuestions;
        },
        clues() {
            const totalClues = _.filter(this.session.context, (element) => {
                return element.triggers && element.triggers.GO_TO_POINT;
            });
            return totalClues;
        },
        completeQuestions() {
            return _.map(this.questions, (question) => {
                const scores = this.groupedScores[question._id] || [];
                const totalScore = _.reduce(
                    scores,
                    (memo, score) => {
                        return memo + score.points;
                    },
                    0
                );
                const answeredRight = _.filter(scores, (score) => {
                    return score.points > 0;
                });

                const hitRate = !scores.length
                    ? 0
                    : +((answeredRight.length / scores.length) * 100).toFixed(
                          0
                      );

                const totalTime = _.reduce(
                    scores,
                    (memo, score) => {
                        return memo + score.time;
                    },
                    0
                );
                /*console.log({
                    ...question,
                    ...{ scores, totalScore, hitRate, totalTime },
                });*/
                return {
                    ...question,
                    ...{ scores, totalScore, hitRate, totalTime },
                };
            });
        },
        completeClues() {
            return _.map(this.clues, (clue) => {
                const scores =
                    this.groupedScores[clue.triggers.GO_TO_POINT] || [];
                const totalScore = _.reduce(
                    scores,
                    (memo, score) => {
                        return memo + score.points;
                    },
                    0
                );
                const reached = _.filter(scores, (score) => {
                    return score.points > 0;
                });

                const hitRate = !scores.length
                    ? 0
                    : +((reached.length / scores.length) * 100).toFixed(0);

                const totalTime = _.reduce(
                    scores,
                    (memo, score) => {
                        return memo + score.time;
                    },
                    0
                );
                return {
                    ...clue,
                    ...{ scores, totalScore, hitRate, totalTime },
                };
            });
        },
        content() {
            let cluesAndQuestions = [];
            if (this.session.context) {
                for (let element of this.session.context) {
                    if (element.triggers && element.triggers.GO_TO_POINT) {
                        cluesAndQuestions = [
                            ...cluesAndQuestions,
                            ..._.filter(this.completeClues, (clue) => {
                                return clue._id == element._id;
                            }),
                        ];
                    } else if (element.type == 'question') {
                        cluesAndQuestions = [
                            ...cluesAndQuestions,
                            ..._.filter(this.completeQuestions, (question) => {
                                return question._id == element._id;
                            }),
                        ];
                    }
                }
            }
            return cluesAndQuestions;
            // console.log('clues & questions', cluesAndQuestions);
        },
        getSectionTitle() {
            if (!this.isTreasurehunt) {
                return this.$t('Sessions.questions_tab_title');
            } else {
                return this.$t('Sessions.clues_questions_tab_title');
            }
        },
        reportInfo() {
            if (this.session) {
                return {
                    gameName: this.session.title,
                    projectName: this.session.project.title,
                    gameType: this.session.project.type,
                };
            }
        },
    },
    mounted() {
        fetchItem('session', this._id).then(({ data }) => {
            this.session = data;
            this.isTreasurehunt = this.session.project.type == 'treasurehunt';
            // console.log('session answers', data);
        });
    },
};
</script>

<style></style>
